// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__mask--SrSnw {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.5);
}
.src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__panel--uj3lr {
  position: fixed;
  right: 0;
  top: 0;
  width: 428px;
  height: 100vh;
  z-index: 10001;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__header--HRWYo {
  padding: 16px 12px 12px 24px;
  box-shadow: 0px -1px 0px 0px #f0f0f0 inset;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__header--HRWYo .src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__title--zZn0E {
  flex: 1;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__listBox--Kbl0q {
  flex: 1;
  overflow-y: auto;
}
.src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__listItem--FXSyT {
  padding: 8px 16px;
  box-shadow: 0px -1px 0px 0px #f0f0f0 inset;
  display: flex;
  flex-direction: row;
}
.src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__itemLeftPart--vkOHh {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__itemRightPart--OoiOf {
  display: flex;
  align-items: center;
  justify-content: center;
}
.src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__time--uvx_d {
  color: rgba(0, 0, 0, 0.55);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* 18px */
}
.src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__itemTitle--j6w95 {
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  /* 22.4px */
}
.src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__entityName--ppWVe {
  color: rgba(0, 0, 0, 0.3);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
.src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__readButton--bj8PV {
  margin: 0;
  padding: 0;
  width: 16px;
  height: 16px;
  border: none;
  background: #e43d00;
  border-radius: 50%;
  cursor: pointer;
}
.src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__allReaded--chlON {
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/MainFrame/Header/ExtNotoficationsPopup/ExtNotoficationsPopup.module.less"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,oCAAA;AAAF;AAEA;EACE,eAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EAEA,aAAA;EACA,sBAAA;AADF;AAGA;EACE,4BAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AADF;AALA;EAQI,OAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAJ;AAIA;EACE,OAAA;EACA,gBAAA;AAFF;AAIA;EACE,iBAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;AAFF;AAIA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;AAIA;EACE,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAFA,SAAS;AACX;AAGA;EACE,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EADA,WAAW;AACb;AAEA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAF;AAEA;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAAF;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAAF","sourcesContent":["@z: 10000;\n.mask {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: @z;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n.panel {\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: 428px;\n  height: 100vh;\n  z-index: @z + 1;\n  background: #fff;\n\n  display: flex;\n  flex-direction: column;\n}\n.header {\n  padding: 16px 12px 12px 24px;\n  box-shadow: 0px -1px 0px 0px #f0f0f0 inset;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  .title {\n    flex: 1;\n    color: rgba(0, 0, 0, 0.85);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 150%;\n  }\n}\n\n.listBox {\n  flex: 1;\n  overflow-y: auto;\n}\n.listItem {\n  padding: 8px 16px;\n  box-shadow: 0px -1px 0px 0px #f0f0f0 inset;\n  display: flex;\n  flex-direction: row;\n}\n.itemLeftPart {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.itemRightPart {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.time {\n  color: rgba(0, 0, 0, 0.55);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 18px */\n}\n.itemTitle {\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 160%; /* 22.4px */\n}\n.entityName {\n  color: rgba(0, 0, 0, 0.3);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px;\n}\n.readButton {\n  margin: 0;\n  padding: 0;\n  width: 16px;\n  height: 16px;\n  border: none;\n  background: #e43d00;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.allReaded {\n  display: flex;\n  flex-direction: row;\n  gap: 6px;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mask": `src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__mask--SrSnw`,
	"panel": `src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__panel--uj3lr`,
	"header": `src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__header--HRWYo`,
	"title": `src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__title--zZn0E`,
	"listBox": `src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__listBox--Kbl0q`,
	"listItem": `src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__listItem--FXSyT`,
	"itemLeftPart": `src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__itemLeftPart--vkOHh`,
	"itemRightPart": `src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__itemRightPart--OoiOf`,
	"time": `src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__time--uvx_d`,
	"itemTitle": `src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__itemTitle--j6w95`,
	"entityName": `src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__entityName--ppWVe`,
	"readButton": `src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__readButton--bj8PV`,
	"allReaded": `src-components-MainFrame-Header-ExtNotoficationsPopup-ExtNotoficationsPopup-module__allReaded--chlON`
};
export default ___CSS_LOADER_EXPORT___;
